import React from 'react';
import { Accordion, AccordionDetails, AccordionSummary, Box, Typography } from '@mui/material';
import { UseRadioGroupTransparent } from '../../lib/formik/Radio';
import { ApplicationProps, Question } from '../../redux-store/types/api-types';
import { mdmsQuestion } from './investor-application';

function DiligenceDeclaration({
  data,
  setData,
  masterDiligenceData,
  application,
}: {
  data: Question[];
  setData: React.Dispatch<React.SetStateAction<Question[]>>;
  masterDiligenceData: mdmsQuestion[];
  application: ApplicationProps | null;
}): JSX.Element {
  return (
    <Box sx={{ width: '100%' }}>
      {masterDiligenceData.map((dataValues, ind) => {
        const matchedDiligence = application?.distributorDiligences.find(
          (diligence) => diligence?.question === dataValues.key
        );
        const isEditDisabled = !!matchedDiligence?.answer;

        return (
          <Accordion
            key={ind}
            sx={{
              boxShadow: 'none',
              mb: 3,
              '&::before': { display: 'none' },
            }}
            expanded>
            <AccordionSummary
              sx={{
                bgcolor: 'rgba(221, 234, 243, 0.2)',
                borderRadius: '5px',
                '&.Mui-expanded': { minHeight: 'unset' },
                '& .MuiAccordionSummary-content': { '&.Mui-expanded': { my: 2 } },
              }}
              aria-controls={`panel${ind}d-content`}
              id={`panel${ind}d-header`}>
              <Typography
                sx={{
                  color: isEditDisabled ? '#57B6BA' : '#131836',
                  fontSize: 14,
                  fontWeight: 600,
                }}>
                {`${ind + 1}. ${dataValues.displayText} ${dataValues.required ? '*' : ''}`}
              </Typography>
            </AccordionSummary>
            <AccordionDetails sx={{ pb: 0 }}>
              {['radio', 'multiSelectCheckBox'].includes(dataValues.questionType) && (
                <UseRadioGroupTransparent
                  name={`distributorDiligence.${ind}.answer`}
                  items={dataValues.values.map((profile) => ({
                    label: profile.label,
                    value: profile.key,
                  }))}
                  value={data[ind]?.answer || ''}
                  onChange={(e) => {
                    const updatedValue = e.target.value;
                    setData((prevData) => {
                      const updatedData = [...prevData];
                      updatedData[ind] = {
                        question: dataValues.key,
                        answer: updatedValue,
                      };
                      return updatedData;
                    });
                  }}
                  disabled={isEditDisabled}
                  sx={{
                    '& .MuiFormGroup-root': { flexDirection: 'column' },
                    '& .MuiFormControlLabel-label': { fontWeight: 400 },
                  }}
                />
              )}
            </AccordionDetails>
          </Accordion>
        );
      })}
    </Box>
  );
}

function DistributorDiligence({
  diligenceData,
  setDiligenceData,
  masterDiligenceData,
  application,
}: {
  diligenceData: Question[];
  setDiligenceData: React.Dispatch<React.SetStateAction<Question[]>>;
  masterDiligenceData: mdmsQuestion[];
  application: ApplicationProps | null;
}): JSX.Element {
  return (
    <DiligenceDeclaration
      data={diligenceData}
      setData={setDiligenceData}
      masterDiligenceData={masterDiligenceData}
      application={application}
    />
  );
}

export default DistributorDiligence;
